import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { get_logout, getProfileData, userList } from "../Services/Operations/ProductAPI";
import { baseURL } from "../Services/api_endpoints";
import { getDeviceToken, onMessageListener } from "../Services/firebaseAuth";
import { logout } from "../Redux/user_information";
import { FaEnvelope, FaLock, FaUser } from "react-icons/fa";


export const Section = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);
  const [addUserMode, setAddUserMode] = useState(false);
  console.log("token : ", token);
  const [firstName, setFirstname] = useState("");
  const [lastName, setLastname] = useState("");
  const [dp, setDp] = useState("");
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("userList")) || []);
  const [searchObj, setSearchObj] = useState([]);
  const [stockNotification, setStockNotification] = useState([]);
  const [currentUser, setCurrentuser] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreteUser = (e) => {
    e.preventDefault();
    console.log("Signup Data:", formData);
  };

  const handleLogOut = async () => {
    const result = await get_logout(token);
    console.log("log out data : ", result);
    dispatch(logout);
    navigate("/login");
    if (result.status === "success") {
      dispatch(logout());
      toast.success("Logout Successfully");
      navigate("/login");
    } else {
      toast.info("User is not login!");
      navigate("/login");
    }
  };

  const handleGetUserData = async () => {
    const res = await getProfileData(token);
    console.log("profile", res);
    if (res.status === "success") {
      setFirstname(res.firstName);
      setLastname(res.lastName);
      setDp(res.profile_pic);
    }
  };

  const handleuserSearch = async (key) => {
    try {
      if (key === "") {
        setSearchObj([]);
      }
      const lowerQuery = key.toLowerCase();
      let list = JSON.parse(localStorage.getItem("userList"));

      const filter = list.filter((item) => {
        return (
          item.firstName?.toLowerCase().includes(lowerQuery) ||
          item.lastName?.toLowerCase().includes(lowerQuery) ||
          item.email?.toLowerCase().includes(lowerQuery) ||
          item.primaryNumber?.toString().includes(lowerQuery) ||
          item.areaLocalitySector?.toLowerCase().includes(lowerQuery) ||
          item.houseBuildingApartment?.toLowerCase().includes(lowerQuery)
        );
      });

      if (key !== "") {
        setSearchObj(filter);
      } else {
        setSearchObj([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = await userList(token);
        console.log("user list:", response);
        setUser(response);
        if (response) localStorage.setItem("userList", JSON.stringify(response));
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchUserList();
  }, []);

  useEffect(() => {
    handleGetUserData();
  }, []);

  useEffect(() => {
    getDeviceToken();

    // 🔔 Listen for foreground messages
    onMessageListener()
      .then((payload) => {
        console.log("Foreground notification received: ", payload);

        setStockNotification((prev) => [
          ...prev,
          { data: payload.notification.body, time: Date.now() },
        ]);
      })
      .catch((err) => console.log("Notification error: ", err));
  }, [stockNotification]);

  return (
    <div>
      <div className="section-body rt-section" id="page_top">
        <div className="container-fluid">
          <div className="page-header rt-bar">
            {/* ================= LEFT : SEARCH ================= */}
            <div className="left rt-left">
              <div className="input-group rt-search">
                <span className="rt-search-icon">
                  <i className="fa fa-search" />
                </span>
                <input
                  type="text"
                  className="form-control rt-search-input"
                  placeholder="Search User"
                  onChange={(e) => handleuserSearch(e.target.value)}
                />
              </div>

              {/* Search results */}
              {searchObj.length > 0 && (
                <div className="rt-results">
                  <div className="rt-results-head">
                    {searchObj.length} user{searchObj.length > 1 ? "s" : ""} found
                  </div>
                  {searchObj.map((i, idx) => (
                    <div
                      className="rt-result-item"
                      key={idx}
                      onClick={() => {
                        setCurrentuser(i);
                        console.log(i);
                      }}
                    >
                      <span className="rt-result-avatar">
                        <i className="fa fa-user" />
                      </span>
                      <div className="rt-result-text">
                        <p className="rt-result-name">
                          {i.firstName} {i.middleName} {i.lastName}
                        </p>
                        <p className="rt-result-meta">
                          <i className="fa fa-envelope-o" /> {i.email}
                          <span className="rt-sep" />
                          <i className="fa fa-phone" /> {i.primaryNumber}
                          <span className="rt-state">-{i.state} </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Selected user detail */}
              {currentUser && (
                <div className="rt-detail">
                  <div className="rt-detail-head">
                    <p className="rt-detail-name">
                      <img
                        className="avatar"
                        src="../assets/images/xs/avatar1.jpg"
                        alt=""
                      />
                      {currentUser.firstName} {currentUser.middleName} {currentUser.lastName}
                    </p>
                    <p className="rt-detail-close" onClick={() => setCurrentuser(null)}>
                      <i className="fa fa-times" />
                    </p>
                  </div>

                  <div className="rt-detail-row">
                    <p>
                      <i className="fa fa-home" /> {currentUser.houseBuildingApartment},
                    </p>
                    <p>
                      <i className="fa fa-map-marker" /> {currentUser.landmark},
                    </p>
                    <p>{currentUser.district}</p>
                  </div>

                  <div className="rt-detail-row">
                    <p>
                      <i className="fa fa-phone" /> {currentUser.primaryNumber},
                    </p>
                    <p>
                      <i className="fa fa-envelope-o" /> {currentUser.email},
                    </p>
                    <p>Age : {currentUser.age}</p>
                  </div>

                  <div className="rt-detail-row">
                    <p>C/o:{currentUser.co},</p>
                    <p>{currentUser.gender},</p>
                    <p>
                      <i className="fa fa-calendar" /> {currentUser.dob[0]}/{currentUser.dob[1]}/
                      {currentUser.dob[2]}
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* ================= ACTION BUTTONS ================= */}
            <button className="rt-btn rt-btn-red" onClick={() => navigate("/user-add")}>
              <i className="fa fa-user-plus" /> Add User
            </button>

            <a href="/get-app" className="rt-btn rt-btn-dark">
              <i className="fa fa-mobile" /> Get App
            </a>

            {addUserMode && (
              <div className="rt-adduser">
                <form onSubmit={handleCreteUser}>
                  <div className="input-group1">
                    <label>Full Name</label>
                    <div className="input-container">
                      <FaUser className="icon" />
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </div>
                  </div>

                  <div className="input-group1">
                    <label>Email Address</label>
                    <div className="input-container">
                      <FaEnvelope className="icon" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        required
                      />
                    </div>
                  </div>

                  <div className="input-group1">
                    <label>Password</label>
                    <div className="input-container">
                      <FaLock className="icon" />
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter your password"
                        required
                      />
                    </div>
                  </div>

                  <div className="input-group1">
                    <label>Confirm Password</label>
                    <div className="input-container">
                      <FaLock className="icon" />
                      <input
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        placeholder="Confirm your password"
                        required
                      />
                    </div>
                  </div>

                  <button type="submit" className="login-button">
                    Create
                  </button>
                </form>
              </div>
            )}

            {/* ================= RIGHT : NOTIFICATIONS + PROFILE ================= */}
            <div className="right rt-right">
              <div className="notification d-flex">
                {/* Notifications */}
                <div className="dropdown d-flex">
                  <a
                    className="nav-link icon d-none d-md-flex btn btn-default btn-icon ml-1 rt-bell"
                    data-toggle="dropdown"
                  >
                    <i className="fa fa-bell" />
                    {stockNotification.length > 0 ? (
                      <span className="rt-bell-count">{stockNotification.length}</span>
                    ) : (
                      <span className="badge badge-primary nav-unread" />
                    )}
                  </a>
                  <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow rt-menu rt-notify">
                    <div className="rt-menu-title">
                      <i className="fa fa-bell" /> Notifications
                    </div>
                    <ul
                      className="list-unstyled feeds_widget rt-feed"
                      style={{ maxHeight: "60vh", height: "fit-content", overflowY: "auto" }}
                    >
                      {stockNotification.length > 0 ? (
                        stockNotification.map((item, idx) => {
                          const dateObj = new Date(item.time);

                          const formatted =
                            dateObj.toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            }) +
                            " " +
                            dateObj.toLocaleTimeString("en-IN", {
                              hour: "2-digit",
                              minute: "2-digit",
                            });
                          return (
                            <li key={idx}>
                              <div className="feeds-left">
                                <span className="avatar avatar-orange rt-feed-icon">
                                  <i className="fa fa-check" />
                                </span>
                              </div>
                              <div className="feeds-body ml-3">
                                <p className="text-muted mb-0 rt-feed-text">
                                  <strong className="text-blue font-weight-bold rt-feed-strong">
                                    Stock Alert :
                                  </strong>{" "}
                                  {item.data}
                                </p>

                                <p className="rt-feed-time">
                                  <i className="fa fa-clock-o" /> {formatted}
                                </p>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <p className="rt-empty">
                          <i className="fa fa-bell-slash-o" />
                          Notifications are removed
                        </p>
                      )}
                    </ul>
                    <div className="dropdown-divider" />
                    <a
                      href="javascript:void(0)"
                      className="dropdown-item text-center text-muted-dark readall rt-readall"
                    >
                      <i className="fa fa-check-square-o" /> Mark all as read
                    </a>
                  </div>
                </div>

                {/* Profile */}
                <div className="dropdown d-flex">
                  <a href="javascript:void(0)" className="chip ml-3 rt-chip" data-toggle="dropdown">
                    <img className="avatar" src={baseURL + "api" + dp} />{" "}
                    <span className="rt-chip-name">
                      {firstName}
                      {"  "}
                      {lastName}
                    </span>
                    <i className="fa fa-angle-down rt-chip-caret" />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow rt-menu">
                    <Link className="dropdown-item rt-item" to="/profile">
                      <i className="dropdown-icon fa fa-user-circle-o" /> Profile
                    </Link>
                    <Link className="dropdown-item rt-item" to="/gst-add">
                      <i className="dropdown-icon fa fa-plus-square-o" /> Gst Add
                    </Link>
                    <Link className="dropdown-item rt-item" to="/gst-list">
                      <i className="dropdown-icon fa fa-list-alt" /> Gst List
                    </Link>
                    <Link className="dropdown-item rt-item" to="/holiday">
                      <i className="dropdown-icon fa fa-calendar-o" /> Holiday
                    </Link>
                    <a className="dropdown-item rt-item" href="app-email.html">
                      <span className="float-right">
                        <span className="badge badge-primary rt-badge">6</span>
                      </span>
                      <i className="dropdown-icon fa fa-envelope-o" /> Inbox
                    </a>
                    <a className="dropdown-item rt-item" href="javascript:void(0)">
                      <i className="dropdown-icon fa fa-paper-plane-o" /> Message
                    </a>
                    <div className="dropdown-divider" />
                    <a className="dropdown-item rt-item" href="javascript:void(0)">
                      <i className="dropdown-icon fa fa-question-circle-o" /> Need help?
                    </a>
                    <a
                      className="dropdown-item rt-item rt-signout"
                      onClick={() => {
                        navigate("/login");
                        //  dispatch(logout)
                      }}
                    >
                      <i className="dropdown-icon fa fa-sign-out" /> Sign out
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
